import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";

import routes from "./routes";
import PrimaryNav from "./components/PrimaryNav";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import { useFormik } from "formik";

const Body = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("jobs")}
      beforeCapture={scope => {
        scope.setTag("module", "jobs");
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

const Jobs = props => {
  const formik = useFormik({
    initialValues: {},
  });

  return (
    <>
      <PrimaryNav formik={formik} />
      <Body formik={formik} {...props} />
    </>
  );
};

export default Jobs;
